import template
    from 'employer/templates/settings/integrations/quickbooks/PayrollItem.ejs';
import RowEditView from 'commons/views/RowEdit';

module.exports = RowEditView.extend({
    tagName: 'tr',

    events: function() {
        var parentEvents = _.isFunction(RowEditView.prototype.events) ?
            RowEditView.prototype.events() :
            RowEditView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'change .js-ext-employee[name=remoteId]':
                'updateEmployeeIntegration',
            'change .js-ext-employer[name=remoteId]':
                'updateEmployerIntegration'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            deletable: true,
            qbAccounts: [],
            employerIntegration: null,
            employeeIntegration: null
        });
        this.options.templateExtra = {
            qbAccounts: this.options.qbAccounts,
            employerIntegration: this.options.employerIntegration,
            employeeIntegration: this.options.employeeIntegration
        };
        return RowEditView.prototype.initialize.apply(this, [this.options]);
    },

    updateEmployeeIntegration: function(ev) {
        this.updateIntegration('employee', ev);
    },

    updateEmployerIntegration: function(ev) {
        this.updateIntegration('employer', ev);
    },

    updateIntegration: function(affects, ev) {
        let $input = this.$(ev.currentTarget);
        let remoteId = this.getInputValue($input);
        let remoteName = $.trim(
            $input.find(`option[value="${remoteId}"]`).text()
        );

        if (affects === 'employee') {
            this.options.employeeIntegration.set({
                remoteId: remoteId,
                remoteName: remoteName
            });
        } else if (affects === 'employer') {
            this.options.employerIntegration.set({
                remoteId: remoteId,
                remoteName: remoteName
            });
        }
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/integrations/quickbooks/PayrollItem.js